var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ion-button',{staticClass:"custom-back-button",attrs:{"fill":"clear","router-direction":"back","button-type":"button"},on:{"click":_vm.navigateBack}},[_c('span',[_vm._v("Back")]),_c('ion-ripple-effect')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }